import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  total: 0,
};

const candidatesSlice = createSlice({
  name: "candidates",
  initialState,
  reducers: {
    clearCandidates: () => {
      return initialState;
    },

    refreshAndSetCandidates: (state, action) => {
      return { ...action.payload };
    },
  },
});

export const { refreshAndSetCandidates, clearCandidates } =
  candidatesSlice.actions;
export default candidatesSlice.reducer;
